'use strict'
export function SafeImage(imageAttributes, viewerIsAdult) {
  if (viewerIsAdult || (imageAttributes && !imageAttributes.isAdultContent)) {
    return imageAttributes
  } else {
    return { gridUrl: '/assets/parental_lock/grid.png', largeUrl: '/assets/parental_lock/grid.png' }
  }
}
